var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app-date-time"},[_c('i',{staticClass:"far fa-calendar-alt"}),_vm._v("\n    "+_vm._s(_vm.formattedDateTime)+" Hrs\n  ")]),_c('div',[_vm._v("\n    Dispensación: "+_vm._s(_vm.location)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }